import Footer from "../../../components/footer";
import { useParams, useNavigate, useLocation } from "react-router-dom";
import { useState, useEffect } from "react";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import { toast, ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { useMediaQuery } from "react-responsive";
import MobileHeader from "../../../components/MobileHeader";
import Header from "../../../components/header";
import { ExternalLink, X } from "lucide-react";
import ReferencePostModal from "../ReferencePostModal";

const BASE_URL = process.env.REACT_APP_BASE_URL;

export default function Publish() {
  const [title, setTitle] = useState("");
  const [doiText, setDoiText] = useState("");
  const [abstract, setAbstract] = useState("");
  const [authors, setAuthors] = useState([]);
  const [selectedDate, setSelectedDate] = useState(new Date());
  const [loading, setLoading] = useState(false);
  const [uploadedFile, setUploadedFile] = useState(null);
  const isMobile = useMediaQuery({ maxWidth: 768 });
  const [currentUser, setCurrentUser] = useState(null);
  const [searchResults, setSearchResults] = useState([]);
  const [isSearching, setIsSearching] = useState(false);
  const [authorInput, setAuthorInput] = useState("");
  const { type } = useParams();
  const location = useLocation();
  const navigate = useNavigate();
  const token = localStorage.getItem("access_token");
  const [visibility, setVisibility] = useState("public");
  const [publicationType, setPublicationType] = useState("Article");
  const [customType, setCustomType] = useState("");
  const [posts, setPosts] = useState([]);
  const [isOpen, setIsOpen] = useState(false);
  const [selectedPostUrl, setSelectedPostUrl] = useState("");
  console.log("The posts are:",posts)

  const publicationTypes = [
    "Article",
    "Conference Paper",
    "Chapter",
    "Book",
    "Thesis",
    "Preprint",
    "Poster",
    "Presentation",
    "Report",
    "Draft",
    "Other",
  ];

  const handlePublicationTypeChange = (e) => {
    const value = e.target.value;
    setPublicationType(value);
    if (value !== "Other") setCustomType("");
    navigate(`/publish/${value}`, { replace: true });
  };

  const handleVisibilityChange = (e) => {
    setVisibility(e.target.value);
  };
 useEffect(() => {
    const fetchPosts = async () => {
      try {
        const token = localStorage.getItem("access_token");

        const response = await fetch(
          `${BASE_URL}/user/publication/all-posts/`,
          {
            method: "GET",
            headers: {
              "Content-Type": "application/json",
              Authorization: token ? `Bearer ${token}` : "",
              "x-api-key": process.env.REACT_APP_X_API_KEY
            },
          }
        );

        const data = await response.json();
        setPosts(data);
      } catch (err) {
        console.error("Fetch failed:", err);
      }
    };

    fetchPosts();
  }, []);
  useEffect(() => {
    setPublicationType(type || "article");

    const fetchCurrentUser = async () => {
      if (!token) {
        toast.error("You must be logged in to upload a publication.");
        return;
      }

      try {
        const res = await fetch(`${BASE_URL}/user/profile/create-profile/`, {
          headers: { Authorization: `Bearer ${token}` ,  "x-api-key": process.env.REACT_APP_X_API_KEY,},
        });

        const data = await res.json();
        if (res.ok && data.data) {
          const username = data.data?.name || "Unknown Author";
          setAuthors([username]);
          setCurrentUser(username);
          localStorage.setItem("user_id", data.data?.user);
        } else {
          toast.error(data?.message || "Failed to fetch user info.");
          setAuthors(["Unknown Author"]);
        }
      } catch (err) {
        console.error("Error fetching user:", err);
        toast.error("Something went wrong while fetching user.");
        setAuthors("Unknown Author");
      }
    };

    if (location.state?.uploadedFile) {
      setUploadedFile(location.state.uploadedFile);
    }

    fetchCurrentUser();
  }, [type, token, location.state]);

  const handleUpload = async () => {
    setLoading(true);

    const currentToken = localStorage.getItem("access_token");
    if (!currentToken) {
      toast.error("You must be logged in to upload a publication.");
      setLoading(false);
      return;
    }

    if (!title.trim()) {
      toast.warning("Title is required.");
      setLoading(false);
      return;
    }

    if (!uploadedFile) {
      toast.warning("Please upload a file.");
      setLoading(false);
      return;
    }

    const formData = new FormData();
    formData.append("title", title);
    formData.append("author", authors);
    formData.append(
      "publication_date",
      selectedDate.toISOString().split("T")[0]
    );
    formData.append(
      "publication_type",
      publicationType === "Other" ? customType.trim() : publicationType
    );
    if (doiText) formData.append("doi", doiText);
    if (abstract) formData.append("abstract", abstract);
    formData.append("upload_document", uploadedFile);
    formData.append("visibility", visibility);
    formData.append("reference",selectedPostUrl)

    try {
      const res = await fetch(`${BASE_URL}/user/publication/publication/`, {
        method: "POST",
        headers: {
          Authorization: `Bearer ${currentToken}`,
          "x-api-key": process.env.REACT_APP_X_API_KEY
        },
        body: formData,
      });

      const data = await res.json();
      if (res.ok) {
        toast.success("Publication uploaded successfully!");
        navigate("/publish-success", { state: { type: publicationType } });
      } else {
        toast.error(data.message || "Failed to upload publication.");
      }
    } catch (err) {
      console.error("Network error:", err);
      toast.error("Network error. Please try again later.");
    } finally {
      setLoading(false);
    }
  };

  const handleFileChange = (e) => {
    if (e.target.files && e.target.files[0]) {
      setUploadedFile(e.target.files[0]);
    }
  };

  const handleSearch = async (query) => {
    if (!query.trim()) {
      setSearchResults([]);
      return;
    }
    setIsSearching(true);
    setSearchResults([]);
    try {
      const res = await fetch(
        `${BASE_URL}/user/publication/search-data/?title=${encodeURIComponent(
          query
        )}`,
        {
          headers: {
            Authorization: `Bearer ${localStorage.getItem("access_token")}`,
            "Content-Type": "application/json",
            "x-api-key": process.env.REACT_APP_X_API_KEY
          },
        }
      );
      const data = await res.json();
      console.log(data);
      if (res.ok) {
        const exactMatchResults = (data.results || []).filter((user) =>
          user.name?.toLowerCase().includes(query.toLowerCase())
        );
        setSearchResults(exactMatchResults);
      } else {
        console.error("Search failed");
      }
    } catch (err) {
      console.error("Search error:", err.message);
    } finally {
      setIsSearching(false);
    }
  };

  return (
  <div>
  {isMobile ? (
    <MobileHeader hideFilter={true} hideHamburger={true} />
  ) : (
    <Header hideFilter={true} />
  )}
  <ToastContainer />
  <div className="mb-[-20px]">
    <div className="bg-transparent py-[30px]">
      <div className="side_image"></div>
      <div className="flex flex-wrap p-2 md:p-5 gap-5 mx-auto w-full items-center justify-center max-w-[780px]">
        <div className="bg-white p-3 md:p-6 rounded-2xl flex-1 min-w-[280px] flex flex-col gap-4 shadow-sm">
          {/* Header */}
          <div className="flex items-center gap-3 mb-4">
            <div className="w-10 h-10 bg-[#e8f0f7] rounded-lg flex items-center justify-center">
              <svg className="w-5 h-5 text-[#0f6abf]" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M12 19l9 2-9-18-9 18 9-2zm0 0v-8" />
              </svg>
            </div>
            <div>
              <h3 className="text-xl font-semibold text-gray-900">Your {type}</h3>
              <p className="text-sm text-gray-500 mt-0.5">Share your work with the community</p>
            </div>
          </div>
         
          {/* Publication Type and File Upload */}
          <div className="flex flex-col md:flex-row gap-5 pt-2.5">
            <div className="mb-2.5 md:flex-1">
              <label className="block font-semibold mb-2 text-sm text-gray-700">Publication type</label>
              <select
                className="w-full h-[50px] px-4 py-2.5 border border-gray-300 rounded-xl bg-white outline-none text-gray-900 text-sm font-medium focus:border-[#0f6abf] focus:ring-2 focus:ring-[#0f6abf]/20 transition-all"
                value={publicationType}
                onChange={handlePublicationTypeChange}
              >
                {publicationTypes.map((pt) => (
                  <option key={pt} value={pt}>
                    {pt.charAt(0).toUpperCase() + pt.slice(1)}
                  </option>
                ))}
              </select>
              {publicationType === "Other" && (
                <input
                  type="text"
                  className="w-full h-[50px] px-4 py-2.5 border border-gray-300 rounded-xl bg-white outline-none text-gray-900 text-sm font-medium focus:border-[#0f6abf] focus:ring-2 focus:ring-[#0f6abf]/20 transition-all mt-2.5"
                  placeholder="Enter your publication type"
                  value={customType}
                  onChange={(e) => setCustomType(e.target.value)}
                />
              )}
            </div>

            <div className="mb-2.5 md:flex-1">
              <label className="block font-semibold mb-2 text-sm text-gray-700">File</label>
              {uploadedFile ? (
                <div className="w-full flex flex-col sm:flex-row items-center gap-3">
                  <div className="w-full relative">
                    {uploadedFile.type.startsWith('image/') ? (
                      <div className="w-full h-32 rounded-xl overflow-hidden border border-gray-200">
                        <img 
                          src={URL.createObjectURL(uploadedFile)} 
                          alt="Preview" 
                          className="w-full h-full object-contain"
                        />
                      </div>
                    ) : (
                      <div className="w-16 h-16 bg-[#e8f0f7] rounded-xl flex items-center justify-center">
                        <svg className="w-8 h-8 text-[#0f6abf]" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M9 12h6m-6 4h6m2 5H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z" />
                        </svg>
                      </div>
                    )}
                    <button
    type="button"
    onClick={() => setUploadedFile(null)}
    className="absolute -top-2 -right-2 w-5 h-5 flex items-center justify-center rounded-full bg-white border border-gray-300 text-red-500 hover:text-red-600 shadow-md transition-colors"
  >
    <X className="w-3 h-3"/>
  </button>
                  </div>
                </div>
              ) : (
                <label className="cursor-pointer w-full h-[50px] bg-gray-50 border-2 border-dashed border-gray-300 rounded-xl px-2.5 py-2.5 text-sm font-medium flex items-center justify-center gap-2 hover:border-[#0f6abf] hover:bg-[#e8f0f7]/10 transition-all">
                  <div className="w-8 h-8 bg-[#e8f0f7] rounded-lg flex items-center justify-center">
                    <svg className="w-4 h-4 text-[#0f6abf]" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M12 4v16m8-8H4" />
                    </svg>
                  </div>
                  <span className="text-gray-700">Select and upload file</span>
                  <input
                    type="file"
                    className="hidden"
                    onChange={handleFileChange}
                  />
                </label>
              )}
            </div>
          </div>

          {/* Title */}
          <div className="mb-2.5">
            <label className="block font-semibold mb-1.5 text-sm text-gray-700">Title</label>
            <textarea
              className="w-full h-[120px] px-4 py-3 border border-gray-300 rounded-xl bg-white outline-none text-gray-900 text-sm font-medium resize-none focus:border-[#0f6abf] focus:ring-2 focus:ring-[#0f6abf]/20 transition-all"
              placeholder={`Enter the title of your ${type}`}
              value={title}
              onChange={(e) => setTitle(e.target.value)}
            ></textarea>
          </div>

          {/* Authors and Date */}
          <div className="flex flex-col md:flex-row gap-5 pt-2.5">
             <div className="mb-2.5 flex-[50%] relative">
              <label className="block font-semibold mb-1.5 text-sm text-gray-700">Authors</label>
              <input
                type="text"
                className="w-full h-[50px] px-4 py-2.5 border border-gray-300 rounded-xl bg-white outline-none text-gray-900 text-sm font-medium focus:border-[#0f6abf] focus:ring-2 focus:ring-[#0f6abf]/20 transition-all"
                value={authorInput}
                placeholder="Author name"
                onChange={(e) => {
                  const value = e.target.value;
                  setAuthorInput(value);
                  if (value.trim() === "") {
                    setSearchResults([]);
                  } else {
                    handleSearch(value);
                  }
                }}
                onKeyDown={(e) => {
                  if (e.key === "Enter" && authorInput.trim() !== "") {
                    e.preventDefault();
                    if (!authors.includes(authorInput.trim())) {
                      setAuthors([...authors, authorInput.trim()]);
                    }
                    setAuthorInput("");
                    setSearchResults([]);
                  }
                }}
              />
              <div className="flex flex-wrap gap-2 mt-2.5">
                {Array.isArray(authors) &&
                  authors.map((author, index) => (
                    <span key={index} className="inline-flex items-center bg-[#e8f0f7] text-[#0f6abf] px-3 py-1.5 rounded-lg text-sm font-medium">
                      {author}
                      <button
                        type="button"
                        className="bg-transparent border-none text-base ml-1.5 cursor-pointer text-[#0f6abf] hover:text-red-500 transition-colors"
                        onClick={() => {
                          setAuthors(authors.filter((a) => a !== author));
                        }}
                      >
                        ×
                      </button>
                    </span>
                  ))}
              </div>
              {authorInput.trim() && searchResults.length > 0 && (
                <div className="absolute z-10 w-full bg-white border border-gray-200 rounded-xl shadow-lg mt-1 max-h-48 overflow-y-auto">
                  {searchResults.map((user) => (
                    <div
                      key={user.id}
                      className="px-4 py-3 cursor-pointer hover:bg-gray-50 flex items-center gap-3"
                      onClick={() => {
                        if (!authors.includes(user.name)) {
                          setAuthors([...authors, user.name]);
                        }
                        setAuthorInput("");
                        setSearchResults([]);
                      }}
                    >
                      <img 
                        src={user.profile_picture || "/default-avatar.png"} 
                        alt={user.name}
                        className="w-8 h-8 rounded-full"
                      />
                      <span className="text-sm text-gray-900">{user.name}</span>
                    </div>
                  ))}
                </div>
              )}
            </div>

            <div className="mb-2.5 md:flex-1">
              <label className="block font-semibold mb-1.5 text-sm text-gray-700">Date</label>
              <div className="w-full">
                <DatePicker
                  selected={selectedDate}
                  onChange={(date) => setSelectedDate(date)}
                  dateFormat="yyyy-MM-dd"
                  className="w-full h-[50px] px-4 py-2.5 border border-gray-300 rounded-xl bg-white outline-none text-gray-900 text-sm font-medium focus:border-[#0f6abf] focus:ring-2 focus:ring-[#0f6abf]/20 transition-all"
                />
              </div>
            </div>
          </div>

          {/* Abstract */}
          <div className="mb-2.5">
            <label className="block font-semibold mb-1.5 text-sm text-gray-700">Abstract</label>
            <p className="m-0 mb-2.5 text-sm text-gray-500">
              Make your article more discoverable by adding additional details.
            </p>
            <textarea
              className="w-full h-[120px] px-4 py-3 border border-gray-300 rounded-xl bg-white outline-none text-gray-900 text-sm font-medium resize-none focus:border-[#0f6abf] focus:ring-2 focus:ring-[#0f6abf]/20 transition-all"
              rows="4"
              placeholder="Explain what your article is about"
              value={abstract}
              onChange={(e) => setAbstract(e.target.value)}
            />
          </div>

          {/* Sharing Options */}
          <div className="mb-2.5">
            <label className="block font-semibold mb-1.5 text-sm text-gray-700">Sharing Options</label>
            <select 
              className="w-full h-[50px] px-4 py-2.5 border border-gray-300 rounded-xl bg-white outline-none text-gray-900 text-sm font-medium focus:border-[#0f6abf] focus:ring-2 focus:ring-[#0f6abf]/20 transition-all"
              value={visibility}
              onChange={handleVisibilityChange}
            >
              <option value="public">Public</option>
              <option value="private">Private</option>
            </select>
          </div>

          {/* DOI */}
          <div className="mb-2.5">
            <label className="block font-semibold mb-1.5 text-sm text-gray-700">
              DOI (optional)
            </label>
            <input
              className="w-full h-[50px] px-4 py-2.5 border border-gray-300 rounded-xl bg-white outline-none text-gray-900 text-sm font-medium focus:border-[#0f6abf] focus:ring-2 focus:ring-[#0f6abf]/20 transition-all"
              type="text"
              placeholder={`Enter ${type} DOI`}
              value={doiText}
              onChange={(e) => setDoiText(e.target.value)}
            />
          </div>
            <div className="mb-2.5">
            <label className="block font-semibold mb-1.5 text-sm text-gray-700">Any Reference Post</label>
            <button 
              className="w-full h-[50px] px-4 py-2.5 border border-gray-300 rounded-xl bg-white outline-none text-gray-900 text-sm font-medium focus:border-[#0f6abf] focus:ring-2 focus:ring-[#0f6abf]/20 transition-all"
              onClick={() => setIsOpen(true)}
            >
              Select Reference Post
            </button>
          </div>
         {selectedPostUrl && (
  <div className="mt-4 p-3 bg-gradient-to-r from-blue-50 to-indigo-50 rounded-xl border border-blue-100">
    <div className="flex items-center gap-2 mb-1">
      <ExternalLink size={16} className="text-blue-500" />
      <span className="text-sm font-medium text-gray-700">Selected Reference Post</span>
    </div>
    <div className="text-sm text-gray-900 font-mono bg-white px-3 py-2 rounded-lg border truncate">
      {selectedPostUrl}
    </div>
  </div>
)}
          {/* Publish Button */}
          <div className="w-full flex justify-center pt-5">
            <button
              className="w-full h-[50px] text-base font-medium bg-[#0f6abf] text-white border-none rounded-xl cursor-pointer hover:bg-[#0a5ca8] transition-colors disabled:opacity-50"
              onClick={handleUpload}
              disabled={loading}
            >
              {loading ? (
                <div className="flex items-center justify-center gap-2">
                  <div className="w-4 h-4 border-2 border-white border-t-transparent rounded-full animate-spin"></div>
                  Publishing...
                </div>
              ) : (
                "Publish"
              )}
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
  <Footer />
      <ReferencePostModal
        isOpen={isOpen}
        onClose={() => setIsOpen(false)}
        onSelect={(url) => setSelectedPostUrl(url)}
      />
</div>

  );
}
